import { render } from "./AppointmentStatus.vue?vue&type=template&id=d3e89274&lang=pug"
import script from "./AppointmentStatus.vue?vue&type=script&lang=js"
export * from "./AppointmentStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__